import * as actionTypes from 'modules/appointments/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = { size: 10 };

const fetchAppointments = (_, { payload }) => payload?.page ?? {};

const setPageSize = (state, { payload }) => ({ ...state, size: payload.size });

const clear = state => {
  const { size } = state;
  return { size };
};

export default createReducer(initialState, {
  [actionTypes.FETCH_APPOINTMENTS_SUCCESS]: fetchAppointments,
  [actionTypes.SET_PAGE_SIZE]: setPageSize,
  [actionTypes.CLEAR_PAGE]: clear,
});
